export const ROOMS = [
    {
        id: 0,
        room_name: "Kitchen"
    },
    {
        id: 1,
        room_name: "Bedroom"
    },
    {
        id: 2,
        room_name: "Lounge"
    },
    {
        id: 3,
        room_name: "Garage"
    },
    {
        id: 4,
        room_name: "Bathroom"
    }
];